// Component registry
const components = {
    slider: () => import('./components/Slider'),
    accordion: () => import('./components/Accordion'),
    tabs: () => import('./components/Tabs'),
    modal: () => import('./components/Modal'),
};

// Initialize all components
export function initComponents() {
    Object.keys(components).forEach(componentName => {
        const elements = document.querySelectorAll(`[data-component="${componentName}"]`);
        
        if (elements.length > 0) {
            components[componentName]().then(module => {
                elements.forEach(element => {
                    new module.default(element);
                });
            }).catch(err => {
                console.error(`Failed to load component: ${componentName}`, err);
            });
        }
    });
}
